import { GridColumnMenuFilterUIProps, GridColumnMenuProps } from "@progress/kendo-react-grid";
import { ColumnMenuWithFilterUi } from "../../../../Layout/Grid/Filter/ColumnMenuWithFilterUi";
import { ContainerNetworkType } from "../../../ViewModel/ContainerNetworkType";
import { CustomFilterUiRadioButton } from "../../../../Layout/Grid/Filter/CustomFilterUiRadioButton";

export function NetworkTypeColumnMenu(props: GridColumnMenuProps) {
  const filterUi = (filterUIProps: GridColumnMenuFilterUIProps) => (
    <CustomFilterUiRadioButton
      {...filterUIProps}
      values={[
        {
          label: ContainerNetworkType.P,
          value: ContainerNetworkType.P,
        },
        {
          label: ContainerNetworkType.S,
          value: ContainerNetworkType.S,
        },
      ]}
    />
  );

  return <ColumnMenuWithFilterUi {...props} filterUI={filterUi} />;
}
